import React from 'react';
import { Modal } from 'react-bootstrap';
export default function Overlay(props) {
  const close = () => {
    if (props.onClose) {
      props.onClose();
    }
    if (props.updateModal) {
      // Update the initial state of the modal
      props.updateModal(false);
    }
  };
  if (!props.show) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: 'modal-container' + ' ' + props.modalClassNames,
    show: props.show,
    onHide: close,
    id: 'dw-overlay-modal'
  }, /*#__PURE__*/React.createElement("div", {
    className: "modal-inner-container"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: props.headerClasses || ''
  }, /*#__PURE__*/React.createElement(Modal.Title, null, /*#__PURE__*/React.createElement("h2", null, props.title)), /*#__PURE__*/React.createElement("button", {
    onClick: close,
    type: "button",
    className: "btn-close",
    "aria-label": "Close"
  }, /*#__PURE__*/React.createElement("svg", {
    className: "close-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: "15.408",
    height: "15.409",
    viewBox: "0 0 12.408 12.409"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M148.907,105.24l3.525,3.524a1.061,1.061,0,0,1,.317.776,1.18,1.18,0,0,1-.317.811l-.776.776a1.18,1.18,0,0,1-.811.317,1.055,1.055,0,0,1-.775-.317l-3.525-3.526-3.525,3.526a1.059,1.059,0,0,1-.776.317,1.183,1.183,0,0,1-.811-.317l-.775-.776a1.173,1.173,0,0,1-.317-.811,1.055,1.055,0,0,1,.317-.776l3.524-3.524-3.524-3.526a1.055,1.055,0,0,1-.317-.776,1.173,1.173,0,0,1,.317-.811l.775-.775a1.176,1.176,0,0,1,.811-.317,1.053,1.053,0,0,1,.776.317l3.525,3.524,3.525-3.524a1.049,1.049,0,0,1,.775-.317,1.173,1.173,0,0,1,.811.317l.776.775a1.18,1.18,0,0,1,.317.811,1.061,1.061,0,0,1-.317.776Z",
    transform: "translate(-140.342 -99.036)",
    fill: "#263c5a"
  })))), /*#__PURE__*/React.createElement(Modal.Body, {
    style: {
      background: props.iframe ? '#f6f6f6' : ''
    }
  }, props.body || props.children || ''), props.showFooter && /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary",
    onClick: close
  }, props.footerButton || 'Close')))));
}